import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, Subject } from 'rxjs';
import {
  BaseAuthenticatedService,
  httpQueryParams,
  PaginatedResponse,
  RecursiveInterface,
} from './base-authenticated.service';
// import { SavedProductInterface } from '@app/interface/savedproduct';
import { ProductServiceInterface } from '@app/interface/product-service';

@Injectable({
  providedIn: 'root',
})
export class ProductserviceApiService extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient // private cookieService: CookieService
  ) {
    super(auth, httpClient);
  }

  // using getRecursivePage
  public getAllProductsServices<T = ProductServiceInterface>(
    invoice_id: number | null,
    organization_id: number | null,
    params: httpQueryParams = {}
  ): Subject<RecursiveInterface<T>> {
    const path = `api/${organization_id}/invoice/${invoice_id}/product-service/`;
    return this.getRecursivePage<T>(path, params);
  }

  public createProductService(
    invoice_id: number,
    organization_id: number,
    service: Partial<ProductServiceInterface>
  ): Observable<ProductServiceInterface> {
    const path = `api/${organization_id}/invoice/${invoice_id}/product-service/`;
    return this.post<ProductServiceInterface>(path, {}, service);
  }

  public updateSavedProductDetails(
    organization_id: number | null,
    id: number,
    data: Partial<ProductServiceInterface>
  ): Observable<ProductServiceInterface> {
    console.log(data);
    return this.partialUpdate<ProductServiceInterface>(
      `api/${organization_id}/saved-product/${id}/`,
      {}, //{ withCredentials: true },
      data
    );
  }

  // In your ProductserviceApiService, add this method:
  public createProductServiceWithTempId(
    organization_id: number,
    service: Partial<ProductServiceInterface>
  ): Observable<ProductServiceInterface> {
    // Use temporary invoice_id = 1
    const path = `api/${organization_id}/invoice/1/product-service/`;
    return this.post<ProductServiceInterface>(path, {}, service);
  }

  public updateProductServiceInvoiceId(
    organization_id: number,
    productServiceId: number,
    newInvoiceId: number
  ): Observable<ProductServiceInterface> {
    const path = `api/${organization_id}/saved-product/${productServiceId}/`;
    return this.partialUpdate<ProductServiceInterface>(
      path,
      {},
      { invoice_id: newInvoiceId }
    );
  }
}
